/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCodeMinus = createReactComponent("outline", "code-minus", "IconCodeMinus", [["path", { "d": "M9 12h6", "key": "svg-0" }], ["path", { "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2", "key": "svg-1" }], ["path", { "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2", "key": "svg-2" }]]);

export { IconCodeMinus as default };
//# sourceMappingURL=IconCodeMinus.mjs.map
